


/** The hook that using to detect the changes of an object */

import { canWrap, isArray, isObject, isPrimitive } from "../../../utils/zone.utils";
import useLayerIdentity, { identityLayer, isLayer } from "../chain/validator/useLayerIdentity";
import useLayerChain from "../chain/useLayerChain";
import useCloneObject from "../utils/useCloneObject";
import { SYM_IS_PROP_ROOT, SYM_LAYER_INDENTIFY, SYM_LAYER_UID, SYM_PROP_LINKING, SYM_ROOT_PROP } from "../../enum/Symbol";
import { emitLayerSet, initOnLayerSet } from "../observable/useOnLayerSet";
import { emitLayerGet, initOnLayerGet } from "../observable/useOnLayerGet";
import useOnLayerAfterSet, { emitLayerAfterSet, initOnLayerAfterSet } from "../observable/useOnLayerAfterSet";
import useDiscard from "../../useDiscard";
import { isPropContainKey } from "../../templateBuilder/util";
import useDeleteSpecialProp from "../utils/useDeleteSpecialProp";
import { getRootProps, isRoot, useMarkRootProp } from "../chain/store/useStoreRoot";
import useWeakMap from "../../utils/useWeakMap";
import { useQueryOriginSource } from "../chain/useQueryOriginal";
import useQueryOriginalSourceByLayer, { storeOriginalSourceByLayer, swapLayerUsingOriginalSource } from "../chain/store/useStoreOriginalSource";
import useOnOriginalSourceChanged from "../observable/useOnOriginalSourceChanged";
import { storeCopySource } from "../chain/store/useStoreCopySource";
import { storeLinkingLayer } from "../chain/store/useStoreRefLayer";
import { deleteLayerUsingOriginalSource, storeLayerUsingOriginalSource } from "../chain/store/useStoreLayerUsingOriginalSource";
import { storePathByLayer } from "../chain/store/useStorePathByLayer";
import useUpdateLayer from "../chain/updater/useUpdateLayer";
import { useCompareIsEqual } from "../utils/useCompare";
import useChangeBox from "../utils/useChangeBox";
import useLayerVersioning from "../utils/useLayerVersioning";
import useLogStack from "../utils/useLogStack";
import storePathBySource, { useQueryPathBySource } from "../chain/store/useStorePathByOriginalSource";
import useSubcribeWhenSourceChanges from "../chain/updater/useUpdater";
import useStrictPropKey, { isPropKeyValid } from "../chain/validator/useStrictPropKey";


// const updateWhenObject = (target, key, value, propertyPath, chainId) => {
//     /**
//      * IMPORTANT
//      * If the prop 'key' is a proxy, need query Proxy then re-update value, make sure not assign new object. Because it will break the reference
//      */
//     if (value && typeof value === 'object' && !isArray(value) && isLayer(target[key]) && !isLayer(value)) {
//         const { queryLayerByPath } = useLayerChain(chainId)
//         const clone = propertyPath.clone();
//         value = Object.assign(target[key], value);
//         clone.push(key);
//         const layer = queryLayerByPath(clone);
//         if (layer) {
//             storeOriginalSourceByLayer(layer, value)
//             return Object.assign(layer, value);
//         }
//         return value;
//     }
// }

// const updateWhenArray = (target, key, value, propertyPath, chainId) => {
//     if (!isArray(value)) return;
//     let array = value;

//     if (isLayer(value)) {
//         array = useQueryOriginalSourceByLayer(value);
//     }
//     if (isLayer(target[key]) && Array.isArray(array)) {
//         target[key] = value;
//         return target[key]
//     } else if (Array.isArray(array)) {
//         return array;
//     }
//     return value
// }

// const updateWhenLayer = (target, key, value, propertyPath, chainId) => {
//     /**
//      * IMPORTANT
//      * If the prop 'key' is a proxy, need query Proxy then re-update value, make sure not assign new object. Because it will break the reference
//      */

//     // console.log("updateWhenLayer", { value, target, key })
//     if (!isLayer(value)) return;
//     if (value && typeof value === 'object' && isLayer(target[key])) {
//         const { queryLayerByPath } = useLayerChain(chainId)
//         const clone = propertyPath.clone();
//         clone.push(key);
//         const layer = queryLayerByPath(clone);
//         if (layer) {
//             // Remove old Ref
//             swapLayerUsingOriginalSource(layer, value, key);
//             // storeLinkingLayer(value, layer)

//             console.log("swap layer", layer)
//             const s = Object.assign(layer, value);
//             // return s;
//             // layer[key] = value;
//             return s;
//         }
//     }
// }


// const tryUpdateIfNotPrimitive = (target, key, value, propertyPath, chainId) => {

//     let updatedValue = updateWhenArray(target, key, value, propertyPath, chainId)
//     if (!!updatedValue) {
//         return updatedValue
//     }

//     updatedValue = updateWhenObject(target, key, value, propertyPath);
//     if (!!updatedValue) {
//         return updatedValue
//     }
//     updatedValue = updateWhenLayer(target, key, value, propertyPath, chainId)
//     if (!!updatedValue) {
//         return updatedValue
//     }

//     Reflect.set(target, key, value);
//     return value;
// }

const storePrivateKey = useWeakMap();
const storeProxyRevocable = useWeakMap();

const byPassProps = new Set([SYM_PROP_LINKING, SYM_ROOT_PROP, SYM_IS_PROP_ROOT])

const isByPass = key => byPassProps.has(key)

/**
 * 
 * @param {*} layer 
 * @param {PropArray} propertyPath 
 * @param {*} key 
 */
const throwErrorIfLayerHasDiscared = (layer, propertyPath, key) => {
    if (!layer) {
        const arr = propertyPath.clone();
        arr.push(key)
        throw `Instance has been destroy. Cannot access to '${arr.pathToString()}'`;
    }
}

const onDiscardLayer = layer => {
    storePrivateKey.delete(layer);
    const revocable = storeProxyRevocable.get(layer);
    if (revocable) {
        revocable.revoke()
        storeProxyRevocable.delete(layer);
    }
}

/**@return {[cloneSource:object, wrapper: ProxyRevocable]} */
const useProxyHandler = (chainId, originalSource, propertyPath) => {

    const cloneSource = useCloneObject(originalSource);
    useMarkRootProp(cloneSource, originalSource);

    /** @returns {PropArray} */
    const cloneArrProp = () => propertyPath.clone();

    let layer = Proxy.revocable(cloneSource, {
        set(target, key, value) {
            // if (key === 'targetItem') debugger
            // if (key === 'userResponse') debugger
         
            throwErrorIfLayerHasDiscared(layer, propertyPath, key);

            const oldValue = target[key];
            if (useCompareIsEqual(value, oldValue, propertyPath, layer.proxy, key)) {
                return true;
            }
            const changeDone = useChangeBox(layer.proxy, propertyPath, key, value, oldValue);
            const version = useLayerVersioning(layer.proxy);
            if (isByPass(key)) {
                console.warn('Ignore assign, Not allow re-update Speical Props');
                return true;
            }
            value = emitLayerSet(storePrivateKey.get(layer.proxy)[0], cloneArrProp(), key, value, oldValue);
            const updated = useUpdateLayer(propertyPath, layer.proxy, key, value, chainId);
            if (updated) {
                const updatedValue = target[key];
                const { notifyLayerChanges } = useLayerChain(chainId);
                notifyLayerChanges(propertyPath, key, value, layer.proxy);
                emitLayerAfterSet(storePrivateKey.get(layer.proxy)[2], cloneArrProp(), key, value, oldValue);
            }
            changeDone();
            // value = tryUpdateIfNotPrimitive(target, key, value, propertyPath, chainId);
            // useUpdateLayer(propertyPath, layer.proxy, key, value)
            return updated;
        },
        get(target, key) {
            throwErrorIfLayerHasDiscared(layer, propertyPath, key)
            if (byPassProps.has(key)) {
                return Reflect.get(...arguments)
            }
            if (typeof cloneSource[key] === 'function') {
                arguments[0] = cloneSource;
                return Reflect.get(...arguments);
            } else if (typeof originalSource[key] === 'function') {
                arguments[0] = originalSource;
                return Reflect.get(...arguments);
            } else if (isLayer(target[key])) {
                return Reflect.get(...arguments);
            }
            let value = target[key] || originalSource[key];
            if (layer) {
                value = emitLayerGet(storePrivateKey.get(layer.proxy)[1], cloneArrProp(), key, value)
            } else {
                console.warn('LayerNull', target[SYM_LAYER_INDENTIFY], 'is null');
            }
            return value;
        },
    })

    storePrivateKey.set(layer.proxy,
        [
            initOnLayerSet(layer.proxy),
            initOnLayerGet(layer.proxy),
            initOnLayerAfterSet(layer.proxy)
        ]
    )

    useDiscard(layer.proxy, onDiscardLayer)

    identityLayer(layer.proxy, '')

    storeOriginalSourceByLayer(layer.proxy, originalSource)

    storeCopySource(layer.proxy, cloneSource);

    storeLayerUsingOriginalSource(originalSource, layer.proxy);

    storeProxyRevocable.set(layer.proxy, layer);

    storePathByLayer(layer.proxy, propertyPath);

    return [cloneSource, layer.proxy];
}

/**@type {WatcherHook} */
const useObjectWatcher = ({ originalSource, propertyPath, chainId }) => {

    const [cloneSource, proxy] = useProxyHandler(chainId, originalSource, propertyPath);

    return {
        layer: proxy,
        copySource: cloneSource
    }
}

export default useObjectWatcher;